// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.initialization-container, .initialization-error-container {
  position: relative;
  background-color: black;
  height: 100%;
  width: 100%;
}

.initialization-container .label, .initialization-error-container .label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 28px;
  text-transform: uppercase;
  font-weight: bold;
}

.image-container-alert {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000000000000000;
}

.image-container-alert .label {
  font-size: 28px;
  font-weight: bold;
  text-transform: uppercase;
}

.initialization-container .label, .image-container-alert .label {
  color: white;
}

.initialization-error-container .label {
  color: red;
}

.shooting-screen-container {
  height: 100%;
  background-color: black;
  position: relative;
  z-index: 1;
}

.initialization-container button,
.initialization-error-container button,
.shooting-screen-container button {
  z-index: 999;
}

.shade {
  display: flex;
  max-height: 100vh;
  max-width: 100vw;
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
  overflow: hidden;
}

.shooting-screen-container {
  width: 100%;
}

.shooting-screen-container .image-container {
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  overflow: hidden;
}

.shooting-screen-container .silhouette {
  bottom: 8%;
  height: 70%;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 200;
  display: none;
}

.shooting-screen-container .fit-to-height {
  height: 100%;
}

.shooting-screen-container .fit-to-width {
  width: 100%;
}

.shooting-screen-container .eye-position-marker {
  position: absolute;
  margin: -24px;
}

.shooting-screen-container .eye-position-parameters {
  position: absolute;
  margin-top: 15px;
  margin-left: 10px;
  font-weight: bold;
  font-size: 13px;
  color: red;
}

.confirmation-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.confirmation-container__header {
  width: 100%;
  padding: 10px;
  flex: none;
  background: whitesmoke;
}

.header .label {
  font-size: 24px;
  font-weight: bold;
}

.photo-list-solo {
  display: flex;
  text-align: center;
  width: 100%;
  padding: 20px;
}

.photo-list-solo__col {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  justify-content: center;
  text-transform: uppercase;
}

.photo-list-solo .cropped-image {
  margin: 10px;
  width: 70%;
  border-radius: 7px;
  border: #448aff 2px solid;
}

.photo-list-several {
  width: 100%;
  display: flex;
  align-items: center;
}

.photo-list-several__elem {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  padding: 5px 20px 20px 20px;
  border: 1px solid #e4e8eb;
  text-transform: uppercase;
  border-radius: 9px;
}

.photo-list-several__elem-active {
  border: 1px solid #448aff;
}

.photo-list-several__elem__label {
  display: flex;
  padding: 10px;
}

.photo-list-several__elem__img {
  height: 35vh;
  margin-bottom: 2px;
}

.photo-list-several__lables {
  display: flex;
  flex-direction: column;
  width: 120px;
  height: 100%;
  padding: 20px;
  justify-content: space-evenly;
  text-align: center;
  text-transform: uppercase;
}

.photo-list-several__scroll1 {
  position: relative;
  flex: auto;
  height: 100%;
}

.photo-list-several__scroll2 {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
}

.photo-list-several__scroll3 {
  display: flex;
}

.command-line {
  display: flex;
  flex-direction: column;
  width: 80px;
  align-items: center;
  justify-content: space-evenly;
}

.command-line button {
  width: 50px;
}

.rotate {
  transform: rotate(180deg);
  transition: 0.75s;
}

.derotate {
  transform: rotate(0deg);
  transition: 0.75s;
}

.image-container__buttons {
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 98%;
  z-index: 500;
  margin: 0 1%;
}

.image-container__buttons button {
  margin: 10px;
}

.confirmation-container__content {
  display: flex;
  height: 100%;
}

.hdr {
  height: 55px;
}

.hdr-space {
  height: 25px;
}

.cam_left__collumn, .cam_right__collumn {
  background: #f8f8fa;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  padding: 10px;
  align-items: center;
  z-index: 3;
}

.image-container {
  box-sizing: border-box;
}

.btn-shoot {
  text-align: center;
}

.btn-cancel {
  width: 55px;
  height: 55px;
  background: #e4e8eb;
  border-radius: 7px;
}

.btn-cancel-init {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.btn-cancel-init button {
  margin: 10px;
}

.btn-confirm {
  width: 55px;
  height: 55px;
  background: #448aff;
  border-radius: 7px;
}

.btn-confirm[disabled] {
  background: #e4e8eb;
}

.btn-confirm__mark {
  color: white;
}

.disable_confirm {
  color: #44494e;
}

.light_icon {
  color: #44494e;
}

.light_icon__active {
  color: #448aff;
}

.disable_rotate {
  color: #e4e8eb !important;
}

.horizontal_line__1 {
  border: 1px solid #59bbd1;
  height: 6%;
  max-width: 100vw;
  position: absolute;
  top: 45%;
  width: 99%;
  z-index: 2;
  overflow: hidden;
}

.horizontal_line__2 {
  border-left: 1px solid #ff7f00;
  border-right: 1px solid #ff7f00;
  height: 6%;
  max-width: 18vh;
  position: absolute;
  top: 45%;
  left: calc(50vw - 6vh);
  width: 12vh;
  z-index: 3;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/photo-wizard/photo-wizard.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAGJ;;AADA;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;AAIJ;;AAFA;EACI,YAAA;AAKJ;;AAHA;EACI,UAAA;AAMJ;;AAJA;EACI,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAOJ;;AALA;;;EAGI,YAAA;AAQJ;;AANA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AASJ;;AAPA;EACI,WAAA;AAUJ;;AARA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAWJ;;AATA;EACI,UAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAYJ;;AAVA;EACI,YAAA;AAaJ;;AAXA;EACI,WAAA;AAcJ;;AAZA;EACI,kBAAA;EACA,aAAA;AAeJ;;AAbA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;AAgBJ;;AAdA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAiBJ;;AAfA;EACI,WAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;AAkBJ;;AAhBA;EACI,eAAA;EACA,iBAAA;AAmBJ;;AAjBA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAoBJ;;AAlBA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;AAqBJ;;AAnBA;EACI,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAsBJ;;AApBA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AAuBJ;;AArBA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAwBJ;;AAtBA;EACI,yBAAA;AAyBJ;;AAvBA;EACI,aAAA;EACA,aAAA;AA0BJ;;AAxBA;EACI,YAAA;EACA,kBAAA;AA2BJ;;AAzBA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;AA4BJ;;AA1BA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AA6BJ;;AA3BA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AA8BJ;;AA5BA;EACI,aAAA;AA+BJ;;AA7BA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;AAgCJ;;AA9BA;EACI,WAAA;AAiCJ;;AA/BA;EACI,yBAAA;EACA,iBAAA;AAkCJ;;AAhCA;EACI,uBAAA;EACA,iBAAA;AAmCJ;;AAjCA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AAoCJ;;AAlCA;EACI,YAAA;AAqCJ;;AAnCA;EACI,aAAA;EACA,YAAA;AAsCJ;;AApCA;EACI,YAAA;AAuCJ;;AArCA;EACI,YAAA;AAwCJ;;AAtCA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AAyCJ;;AAvCA;EACI,sBAAA;AA0CJ;;AAxCA;EACI,kBAAA;AA2CJ;;AAzCA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA4CJ;;AA1CA;EACI,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;AA6CJ;;AA3CA;EACI,YAAA;AA8CJ;;AA5CA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA+CJ;;AA7CA;EACI,mBAAA;AAgDJ;;AA9CA;EACI,YAAA;AAiDJ;;AA/CA;EACI,cAAA;AAkDJ;;AAhDA;EACI,cAAA;AAmDJ;;AAjDA;EACI,cAAA;AAoDJ;;AAlDA;EACI,yBAAA;AAqDJ;;AAlDA;EACI,yBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;AAqDJ;;AAnDA;EACI,8BAAA;EACA,+BAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AAsDJ","sourcesContent":[".initialization-container, .initialization-error-container {\n    position: relative;\n    background-color: black;\n    height: 100%;\n    width: 100%;\n}\n.initialization-container .label, .initialization-error-container .label {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    font-size: 28px;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n.image-container-alert {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999999999999999;\n}\n.image-container-alert .label {\n    font-size: 28px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n.initialization-container .label, .image-container-alert .label {\n    color: white;\n}\n.initialization-error-container .label {\n    color: red;\n}\n.shooting-screen-container {\n    height: 100%;\n    background-color:black;\n    position: relative;\n    z-index: 1;\n}\n.initialization-container button,\n.initialization-error-container button,\n.shooting-screen-container button {\n    z-index: 999;\n}\n.shade {\n    display: flex;\n    max-height: 100vh;\n    max-width: 100vw;\n    height: 100vh;\n    width: 100vw;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n.shooting-screen-container {\n    width: 100%;\n}\n.shooting-screen-container .image-container {\n    width: 100%;\n    height: 100%;\n    z-index: 100;\n    position: absolute;\n    overflow: hidden;\n}\n.shooting-screen-container .silhouette {\n    bottom: 8%;\n    height: 70%;\n    left: 0;\n    position: absolute;\n    width: 100%;\n    z-index: 200;\n    display: none;\n}\n.shooting-screen-container .fit-to-height {\n    height: 100%;\n}\n.shooting-screen-container .fit-to-width {\n    width: 100%;\n}\n.shooting-screen-container .eye-position-marker {\n    position: absolute;\n    margin: -24px;\n}\n.shooting-screen-container .eye-position-parameters {\n    position: absolute;\n    margin-top: 15px;\n    margin-left: 10px;\n    font-weight: bold;\n    font-size: 13px;\n    color: red;\n}\n.confirmation-container {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n.confirmation-container__header {\n    width: 100%;\n    padding: 10px;\n    flex: none;\n    background: whitesmoke;\n}\n.header .label {\n    font-size: 24px;\n    font-weight: bold;\n}\n.photo-list-solo {\n    display: flex;\n    text-align: center;\n    width: 100%;\n    padding: 20px;\n}\n.photo-list-solo__col {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    height: 100%;\n    justify-content: center;\n    text-transform: uppercase;\n}\n.photo-list-solo .cropped-image {\n    margin: 10px;\n    width: 70%;\n    border-radius: 7px;\n    border: #448aff 2px solid;\n}\n.photo-list-several {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n.photo-list-several__elem {\n    display: flex;\n    flex-direction: column;\n    margin-right: 30px;\n    padding: 5px 20px 20px 20px;\n    border: 1px solid #e4e8eb;\n    text-transform: uppercase;\n    border-radius: 9px;\n}\n.photo-list-several__elem-active {\n    border: 1px solid #448aff;\n}\n.photo-list-several__elem__label {\n    display: flex;\n    padding: 10px;\n}\n.photo-list-several__elem__img {\n    height: 35vh;\n    margin-bottom: 2px;\n}\n.photo-list-several__lables {\n    display: flex;\n    flex-direction: column;\n    width: 120px;\n    height: 100%;\n    padding: 20px;\n    justify-content: space-evenly;\n    text-align: center;\n    text-transform: uppercase;\n}\n.photo-list-several__scroll1 {\n    position: relative;\n    flex: auto;\n    height: 100%;\n}\n.photo-list-several__scroll2 {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: flex;\n    align-items: center;\n}\n.photo-list-several__scroll3 {\n    display: flex;\n}\n.command-line {\n    display: flex;\n    flex-direction: column;\n    width: 80px;\n    align-items: center;\n    justify-content: space-evenly;\n}\n.command-line button {\n    width: 50px;\n}\n.rotate {\n    transform: rotate(180deg);\n    transition: 0.75s;\n}\n.derotate {\n    transform: rotate(0deg);\n    transition: 0.75s;\n}\n.image-container__buttons {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    position: fixed;\n    width: 98%;\n    z-index: 500;\n    margin: 0 1%;\n}\n.image-container__buttons button {\n    margin: 10px;\n}\n.confirmation-container__content {\n    display: flex;\n    height: 100%;\n}\n.hdr {\n    height: 55px;\n}\n.hdr-space {\n    height: 25px;\n}\n.cam_left__collumn, .cam_right__collumn {\n    background: #f8f8fa;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 80px;\n    padding: 10px;\n    align-items: center;\n    z-index: 3;\n}\n.image-container {\n    box-sizing: border-box;\n}\n.btn-shoot {\n    text-align: center;\n}\n.btn-cancel {\n    width: 55px;\n    height: 55px;\n    background: #e4e8eb;\n    border-radius: 7px;\n}\n.btn-cancel-init {\n    width: fit-content;\n    height: fit-content;\n}\n.btn-cancel-init button {\n    margin: 10px;\n}\n.btn-confirm {\n    width: 55px;\n    height: 55px;\n    background: #448aff;\n    border-radius: 7px;\n}\n.btn-confirm[disabled] {\n    background: #e4e8eb;\n}\n.btn-confirm__mark {\n    color: white;\n}\n.disable_confirm {\n    color: #44494e;\n}\n.light_icon {\n    color: #44494e;\n}\n.light_icon__active {\n    color: #448aff;\n}\n.disable_rotate {\n    color: #e4e8eb!important;\n}\n\n.horizontal_line__1 {\n    border: 1px solid #59bbd1;\n    height: 6%;\n    max-width: 100vw;\n    position: absolute;\n    top: 45%;\n    width: 99%;\n    z-index: 2;\n    overflow: hidden;\n}\n.horizontal_line__2 {\n    border-left: 1px solid #ff7f00;\n    border-right: 1px solid #ff7f00;\n    height: 6%;\n    max-width: 18vh;\n    position: absolute;\n    top: 45%;\n    left: calc(50vw - 6vh);\n    width: 12vh;\n    z-index: 3;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
